// 公棚
export default {
  path: '/shed',
  title: '公棚设置',
  icon: 'flask',
  children: (pre => [
    { path: `${pre}/index`, title: '基本信息', icon: 'iconoperate_bob_information', auth_token: 'xg:shed:index' },
    { path: `${pre}/intro`, title: '公棚简介', icon: 'iconoperate_bob_brief', auth_token: 'xg:shed:intro' },
    // { path: `${pre}/notice`, title: '滚动公告', icon: 'iconoperate_bob_notice', auth_token: 'xg:shed:notice' }
  ])(
    '/shed'
  )
}
